import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { teacher, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', color: '#6b7280', fontFamily: 'system-ui, sans-serif',
      }}>
        Loading...
      </div>
    );
  }

  if (!teacher) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
